<template>
  <p class="V-baseline">
    <!-- readonly state -->
    <span v-if="!inputing && !loading">
      {{ $t('shopping_cart.payment.estimatedTax', 'Estimated tax') }}
      <span v-if="!!zipCode" class="text-left">
        <a class="btn-toggle" @click.prevent="edit">
          {{ zipCode }}
        </a>
      </span>
    </span>
    <span v-if="!inputing && !loading && !zipCode">
      <a
        href="##"
        class="btn-toggle"
        @click.prevent="edit"
      >
        <span>
          {{ $t('shopping_cart.payment.calculateTax', 'Calculate') }}
        </span>
      </a>
    </span>
    <span v-if="!inputing && !loading && zipCode">{{ tax | formatCurrency(true) }}</span>
    <!-- readonly state -->

    <!-- editing state -->
    <app-spinner :rhombus-size="10" :color="'#9b9b9b'" v-if="loading" />
    <r-app-text-input-with-button
      v-if="inputing && !loading"
      :label="$t('shopping_cart.payment.enterZipCode', 'Enter zip code')"
      v-model.trim="zipCode"
      :button-label="$t('shopping_cart.payment.applyZipCodeButton', 'Apply')"
      :top-label="true"
      :errors="errors"
      :button-class="'btn-toggle'"
      class="Input"
      :tips="$t('shopping_cart.payment.zipCodeTips', 'Must consists of 5 digits')"
      @apply="query"
      @input="validate" />
    <span v-if="inputing && !loading">
      <a
        href="##"
        class="btn-toggle"
        @click.prevent="cancel"
      >
        <span>
          {{ $t('shopping_cart.payment.cancelCalculateTax', 'Cancel') }}
        </span>
      </a>
    </span>
    <!-- editing state -->
  </p>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { extractErrorMessage } from '@/utilities/common'
  import { detectedCulture } from '@/utilities/common/culture'
  import { zipCodeRegexs } from 'utilities/common/validators'
  import { find } from 'lodash'

  export default {
    name: 'cart-estimated-tax',

    data () {
      return {
        querying: false,
        inputing: false,
        loading: false,
        zipCode: '',
        errors: [],
        currentZipCode: ''
      }
    },

    props: {
      bundles: {
        type: Array,
        default () {
          return []
        }
      },
      tax: {
        type: Number,
        default: 0
      }
    },

    computed: {
      ...mapGetters('account', ['isAuthenticated'])
    },

    methods: {
      edit () {
        this.inputing = true
      },

      async cancel () {
        this.errors = []
        this.inputing = false
        this.zipCode = this.currentZipCode
      },

      validate () {
        this.errors = []
        if (!this.zipCode) {
          this.errors.push(this.$t('shopping_cart.payment.validation.zipCodeRequired', 'The zip code is required'))
          return false
        }
        const regex = find(zipCodeRegexs, { 'code': detectedCulture.countryCode })['regex']
        if (!regex.test(this.zipCode)) {
          this.errors.push(this.$t('shopping_cart.payment.validation.zipCode', 'Invalid zip code'))
          return false
        }

        return true
      },

      query () {
        // validate zipCode
        if (!this.validate()) {
          this.loading = false
          return
        }
        this.loading = true
        this.$store.commit('checkout/setSubscriptionIsPreviewing', true)
        this.$store.dispatch('checkout/getCartDetails', {
          bundles: this.bundles,
          excludePrice: false,
          zipCode: this.zipCode
        }).then(data => {
          this.loading = false
          this.inputing = false
          this.currentZipCode = this.zipCode
          window.localStorage.setItem('currentEstimatedZipCode', this.currentZipCode)
          this.$store.commit('checkout/setSubscriptionIsPreviewing', false)
        }).catch(error => {
          this.loading = false
          this.$notify({
            type: 'error',
            title: extractErrorMessage(error)
          })
        })
      }
    },

    async mounted () {
      if (this.isAuthenticated) {
        this.loading = true
        try {
          const currentEstimatedZipCode = window.localStorage.getItem('currentEstimatedZipCode')
          if (currentEstimatedZipCode) {
            this.zipCode = currentEstimatedZipCode
            this.query()
          } else {
            const profile = await this.$store.dispatch('account/fetchProfile')
            this.zipCode = profile.shipping && profile.shipping.zipCode
            this.query()
          }
          this.$bus.$on('update-zipcode', zipcodeFromShippingAddress => {
            this.zipCode = zipcodeFromShippingAddress
            this.query()
          })
        } catch (error) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(error)
          })
          this.loading = false
        }
      } else {
        const currentEstimatedZipCode = window.localStorage.getItem('currentEstimatedZipCode')
        if (currentEstimatedZipCode) {
          this.zipCode = currentEstimatedZipCode
          this.query()
        }
      }
    }
  }
</script>
<style lang="scss">
  p.V-baseline {
    align-items: baseline;

    .Input {
      width: 80%;
    }

    .btn-toggle {
      font-size: .16rem;
      line-height: .24rem;
      color: $blue;
      font-weight: 500;
    }

    .toggle-externals {
      margin-top: .4rem;
    }

    .AppSpinner {
      position: relative !important;
      top: 0 !important;
      right: 0 !important;
      left: 0 !important;
    }
  }
</style>
